//* Vue Router
import type { RouteLocationNormalizedGeneric } from "vue-router";
//* 全局工具函数
import { Formats } from "@/assets/js";

//* 校验函数
const verify = async function (route: RouteLocationNormalizedGeneric, token?: null | string) {
    //* Token不存在清空登录状态并检测页面是否需要重定向
    if (!token) return false;
    else {
        try {
            const response = await api.middleware("User", route, "/api/user", { headers: { "X-Token": token }, hidden: true });
            if (response.value) return response;
            else {
                return false;
            }
        } catch {
            return false;
        }
    }
};

//* 用户登录信息
export default defineNuxtRouteMiddleware(async (to, from) => {
    // http://172.21.1.152:7788/?access_token=$2b$12$9BdE9vNyoHSsqQH/ZckYh.v/PW6MUa4GegsyaQ8Cewx4gAzCGM916&display=pc&language=zh
    //* 服务端仅校验Token是否有效，并将Token数据保存到Cookie中
    if (import.meta.server) {
        //* store数据
        const user = useUserStore();
        //* cookie数据
        const cookie = useCookie("X-Token", { maxAge: 1296000 });
        //* 初始化数据
        const token = Formats.query(to.query.access_token) || cookie.value;
        //* 校验Token是否有效
        const result = await verify(to, token);
        //* 更新用户信息，但暂不更新Token，因为Token是在服务端更新无法触发watch
        if (result) user.update(result.value);
        else {
            //* Token数据清空
            cookie.value = "";
            //* 检测页面是否需要重定向
            if (to.meta.permission) {
                return navigateTo(routerResolve({ name: "Home" }).route, { replace: true });
            }
        }
    }
});
